export { default } from './HoldsEmptyContentPanel';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsEmptyContentPanel/index.js